import React from 'react';
import { Grid } from '@material-ui/core';
import AnalyticsViews from './AnalyticsViews';

const Analytics = () => {
    return <Grid container direction="column">
        <AnalyticsViews/>
    </Grid>
}

export default Analytics;